import Vue from "vue";
import LaravelError from "@/app/Http/concerns/LaravelError";
import {AxiosError} from "axios";
import VueI18n from "vue-i18n";

export default Vue.extend({
    watch: {
        route: {
            immediate: true,
            handler() {
                const self = this as Vue;

                self.$root.messages = [];
            },
        },
    },
    methods: {
        defaultErrorHandler(error: AxiosError<LaravelError> | AxiosError): void {
            if (
                !error.response
                || !error.response.data
                || !error.response.data.errors
                || Object.keys(error.response.data.errors).length === 0
            ) {
                this.flash(this.$t('Whoops. Something went wrong.') as string);
                return;
            }

            const laravelError = error.response.data as LaravelError;

            Object.values(laravelError.errors)
                .forEach((grouped: string[]) => {
                    grouped.forEach((error: string) => {
                        this.flash(error);
                    });
                });
        },
        flash(message: string | VueI18n.TranslateResult, duration: number = 3000): Promise<void> {
            const self = this as Vue;

            // @ts-ignore
            // noinspection TypeScriptUnresolvedFunction
            return self.$root.$flash(message, duration);
        },
        resetFlash(): void {
            const self = this as Vue;

            self.$root.messages = [];
        },
    },
});